module.exports = __webpack_public_path__ + "static/media/fancy_4_bottom.aa14a7ec.svg";